import { tableConstantsFactory } from './tableConstantsFactory';
const cabinetFilterOptionsConstants = tableConstantsFactory('CABINETFILTEROPTIONS');
cabinetFilterOptionsConstants.SET_CURRENT = 'CABINET_SET_CURRENT';
export default cabinetFilterOptionsConstants;